export default __webpack_public_path__ + "static/media/3.902a1bb6.jpg";